import React from 'react';
import { useHistory } from 'react-router-dom';
import { CardFooter } from '../../shared/card/card-footer';
import { Button } from '../../shared/button/button';
import './card-error-handling.scss';
export var CardErrorHandlingFooter = function (_a) {
    var url = _a.url;
    var history = useHistory();
    var tryAgain = function () {
        if (url && url.length > 1) {
            history.push(url);
        }
        else {
            history.goBack;
        }
    };
    return (React.createElement(CardFooter, null,
        React.createElement("footer", null,
            React.createElement("div", null,
                React.createElement(Button, { type: "button", variant: "primary", childClasses: "full-width", onClick: tryAgain }, "Try Again")))));
};
